<script>
// import Translations from "./insert-me-to-translate.vue";

import isInteger from 'lodash/isInteger';
import Url from "domurl";

const blockedEditCookieName = 'promoted_post_blocked_editing';

export default {
    props: {
        editLimitTimestampSeconds: {
            type: Number,
            required: false,
            default: 0,
            validator: (value) => {
                return value >= 0;
            }
        },
        activePromotionLightboxText: {
            type: String,
            required: true,
        },
        postPrivateCode: {
            type: String,
            required: true,
        },
        postEditUrl: {
            type: String,
            required: true,
        },
    },
    components: {
        UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
    },
    data: function() {
        return {
            remainingSeconds: null,
        }
    },

    created() {
        this.remainingSeconds = Math.round(this.editLimitTimestampSeconds - Date.now()/1000);
        if(this.remainingSeconds >= 0) {
            const intervalId = setInterval(() => {
                const remaining = Math.round(this.editLimitTimestampSeconds - Date.now()/1000);
                if(remaining < 0){
                    clearInterval(intervalId);
                }
                this.remainingSeconds = remaining;
            }, 1000);
        }
    },

    mounted() {
        const blockedEdit = this.$cookies.get(blockedEditCookieName);
        if (blockedEdit && blockedEdit === this.postPrivateCode) {
            this.$store.dispatch("ui/lightbox/show", {
                title: gettext("Error"),
                body: this.activePromotionLightboxText,
            });
            this.$cookies.remove(blockedEditCookieName, null, locations.cookie_domain);
        }
    },

    computed: {
        expired() {
            return isInteger(this.remainingSeconds) && this.remainingSeconds < 0;
        },

        minutesLabel() {
            const minutesStr = Math.floor(this.remainingSeconds/60).toString();
            if (minutesStr.length == 1) {
                return "0" + minutesStr;
            }
            return minutesStr;
        },

        secondsLabel() {
            return ("0" + Math.floor(this.remainingSeconds % 60)).slice(-2);
        },
        editHref () {
            return this.postEditHref;
        },
    },

    methods: {
        openEdit() {
            const currentUrl = new Url();
            const redirectUrl = new Url(this.postEditUrl);

            if(currentUrl.path === redirectUrl.path) {
                // same page, do nothing
                return;
            }

            // add next query string parameter
            redirectUrl.query.next = currentUrl;

            window.location.href = redirectUrl;
        },
    },
}
</script>